export default __webpack_public_path__ + "static/media/bg2.8df12b44.jpg";